<template>
  <Layout>
      <div class="row"  >

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4>Company Settings</h4><br>
            <form @submit.prevent="UpdateSettings">
              <div class="row">
                

                  <div class="col-md-4">
                    
                   
                    <div class="form-group mb-2">
                      <label>Show Detailed Receipt</label>
                        <select class="form-control" v-model="print_trans">
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                    </div> 
                   
                  </div>
                  <div class="col-md-4">
                       
                    
                  
                    <div class="form-group"><br>
                    <b-button type="submit" class="btn w-100 mt-2" variant="primary"><i class="fas fa-check-circle"></i> Update</b-button>
                    </div>
                  </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
   
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Facility Profile",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      
      print_trans:1,
     
    };
  },
  methods: {
    
    async UpdateSettings() { 
        let formData = new FormData();
        
        formData.append("print_trans", this.print_trans);
       
        let url = "/updatefacilitysettings";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          let userData=response.data.user;
          localStorage.setItem('user', JSON.stringify(userData));
          this.$toast.success("Settings Updated");
        }
        });
      },
  },
  mounted() {
   
    this.print_trans=this.userData.settings.print_trans;
  
  },
  
};
</script>